import { useState } from "react";
import api from "../../api/axios";

const UrlImportPage = ({ embedded = false }) => {
  const workspaceId = "eca5db98-571b-4735-81b4-505676753b64";

  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleImport = async () => {
    try {
      setLoading(true);
      setMessage("");

      const res = await api.post("/import/url", {
        workspaceId,
        url,
      });

      setMessage(
        `Imported successfully. ${res.data.chunksStored} chunks stored.`
      );
    } catch (err) {
      setMessage("Import failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={embedded ? "" : "container mt-5"}
      style={
        embedded
          ? {
              padding: "8px 0 0 0",
            }
          : {}
      }
    >
      <div className={embedded ? "" : "card shadow-sm"}>
        <div className={embedded ? "" : "card-body"}>
          <h4 className="mb-4">Import from URL</h4>

          <div className="mb-3">
            <label className="form-label">Website URL</label>
            <input
              type="text"
              className="form-control"
              placeholder="https://example.com"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>

          <button
            className="btn btn-primary"
            onClick={handleImport}
            disabled={loading}
          >
            {loading ? "Importing..." : "Import & Embed"}
          </button>

          {message && (
            <div className="alert alert-info mt-3">
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UrlImportPage;